import React from 'react';

import useAuth from './auth';

const Context = React.createContext();

const AuthProvider = ({ children }) => {

    const { authenticated, authenticatedUser, userSubscription, userProfiles, userPermissions, handleLogin, handleLogout } = useAuth();

    return (
        <Context.Provider value={{ authenticated, authenticatedUser, userSubscription, userProfiles, userPermissions, handleLogin, handleLogout }}>
            {children}
        </Context.Provider>
    );
}


export { AuthProvider };